import { MutateOptions, useMutation } from '@tanstack/react-query';
import { UniversalChatThreadDestroyInput, UniversalChatThreadDestroyPayload } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TVariables = UniversalChatThreadDestroyInput;
type TData = UniversalChatThreadDestroyPayload;

export const useUniversalChatThreadDelete = (
  options: MutateOptions<TData, TGenericError, TVariables, unknown> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    mutation universalChatThreadDestroy($input: UniversalChatThreadDestroyInput!) {
      universalChatThreadDestroy(input: $input) {
        errors
        errorCode
        success
      }
    }
  `;

  return useMutation<TData, TGenericError, TVariables, unknown>({
    ...options,
    mutationFn: (input: TVariables) =>
      client.request({
        data: {
          gql: graphql,
          variables: { input }
        }
      })
  });
};
